export default __webpack_public_path__ + "static/media/tools.68395d74.svg";